/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const More: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="more" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M340 793.3475C277.6525 793.3475 226.6525 742.3475 226.6525 680S277.6525000000001 566.6524999999999 340 566.6524999999999C402.3475000000001 566.6524999999999 453.3475 617.6524999999999 453.3475 680S402.3475000000001 793.3475 340 793.3475zM1020 793.3475C957.6525 793.3475 906.6525 742.3475 906.6525 680S957.6525 566.6524999999999 1020 566.6524999999999C1082.3474999999999 566.6524999999999 1133.3475 617.6524999999999 1133.3475 680S1082.3475 793.3475 1020 793.3475zM680 793.3475C617.6525 793.3475 566.6525 742.3475 566.6525 680S617.6525 566.6524999999999 680 566.6524999999999C742.3475 566.6524999999999 793.3475000000001 617.6524999999999 793.3475000000001 680S742.3475000000001 793.3475 680 793.3475z" : "M272 634.678C222.122 634.678 181.322 593.878 181.322 544S222.122 453.3219999999999 272 453.3219999999999C321.8780000000001 453.3219999999999 362.678 494.122 362.678 544S321.8780000000001 634.678 272 634.678zM816 634.678C766.1220000000001 634.678 725.3219999999999 593.878 725.3219999999999 544S766.122 453.3219999999999 816 453.3219999999999C865.8779999999999 453.3219999999999 906.6780000000002 494.122 906.6780000000002 544S865.878 634.678 816 634.678zM544 634.678C494.122 634.678 453.322 593.878 453.322 544S494.122 453.3219999999999 544 453.3219999999999C593.8779999999999 453.3219999999999 634.6780000000001 494.122 634.6780000000001 544S593.878 634.678 544 634.678z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
More.displayName = `Blueprint5.Icon.More`;
export default More;
